import { SocialPlatform } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

const PLATFORM_LABELS: Record<SocialPlatform, string> = {
  twitter: 'Connect X / Twitter',
  linkedin: 'Connect LinkedIn',
  facebook: 'Connect Facebook',
  instagram: 'Connect Instagram',
};

interface AccountConnectButtonProps {
  platform: SocialPlatform;
  onConnect: (platform: SocialPlatform) => void;
  disabled?: boolean;
}

export function AccountConnectButton({ platform, onConnect, disabled }: AccountConnectButtonProps) {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => onConnect(platform)}
      disabled={disabled}
      className="gap-2"
    >
      <Plus className="h-4 w-4" />
      {PLATFORM_LABELS[platform]}
    </Button>
  );
}
